// import './messenger.scss';

export { default } from './Messenger';
export { default as template } from './messenger.tpl';
